import { Link, useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions } from "./redux/StateReducer";
import { adjustForNav } from "./helpers/utils";

const AppNav = (props) => {
  const dispatch = useDispatch();
  const courseCurriculumOpen = useSelector(
    (state) => state.courseCurriculumOpen
  );
  const screenListOpen = useSelector((state) => state.screenListOpen);
  const user = useSelector((state) => state.user);

  const { leftLink, leftTitle, completed, title } = props;
  const [searchVal, setSearchVal] = useState("");
  const [showTutorialMenuBtn, setShowTutorialMenuBtn] = useState(true);

  const currLocation = useLocation();
  const pathName = currLocation.pathname;

  React.useEffect(() => {
    setShowTutorialMenuBtn(
      !(
        pathName.includes("/courses/") ||
        pathName.includes("/sections/") ||
        pathName.includes("_slides/") ||
        pathName.includes("/dashboard") ||
        pathName.includes("/flash-cards") ||
        pathName.includes("/activity-log")
      )
    );
    adjustForNav();
  });

  const showToolsAndCompany =
    pathName.includes("/courses/") ||
    pathName.includes("/dashboard") ||
    pathName.includes("/activity-log") ||
    pathName.includes("/flash-cards");

  return (
    <nav
      id="algodaily-nav"
      className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top ad-global-nav"
    >
      {!props.hideSidebars && !pathName.includes("_slides/") ? (
        <div className="d-none d-lg-block nav-item text-nowrap mr-3">
          <button
            className="ad-nav-icon-button"
            type="button"
            aria-label="Toggle course curriculum"
            onClick={(e) => {
              const newCourseCurriculumOpen = !courseCurriculumOpen;
              dispatch({
                type: actions.SET_COURSE_CURRICULUM_OPEN,
                payload: newCourseCurriculumOpen,
              });
              localStorage &&
                localStorage.setItem(
                  "adCourseCurriculumOpen",
                  newCourseCurriculumOpen
                );
            }}
            data-tip="Toggle the left side curriculum menu"
          >
            <i className="fa fa-bars" aria-hidden="true"></i>
          </button>
        </div>
      ) : null}

      {leftTitle && leftLink ? (
        <Link className="navbar-brand" to={leftLink}>
          <i className="fa fa-caret-left" aria-hidden="true"></i> {leftTitle}
        </Link>
      ) : pathName.includes("/dashboard") ? (
        <a className="navbar-brand" href="/dashboard">
          <span className="ad-brand-mark">A</span>
          <span>AlgoDaily</span>
        </a>
      ) : !user ? (
        <a className="navbar-brand" href="/">
          <span className="ad-brand-mark">A</span>
          <span>AlgoDaily</span>
        </a>
      ) : (
        <Link className="navbar-brand" to={"/dashboard"}>
          <i className="fa fa-caret-left" aria-hidden="true"></i> Today
        </Link>
      )}

      {!showToolsAndCompany ? (
        <ul
          className="d-none d-lg-block navbar-nav m-lg-auto d-lg-flex"
          style={{ flexGrow: 1 }}
        >
          <li className="nav-brand text-nowrap m-lg-auto">
            <p className="nav-link ad-nav-lesson-title text-white p-0 m-0">
              {completed ? (
                <>
                  <s>
                    {title.length > 60 ? title.substr(0, 60) + "..." : title}
                  </s>{" "}
                  <i className="fa fa-check"></i>
                </>
              ) : title.length > 60 ? (
                title.substr(0, 60) + "..."
              ) : (
                title
              )}
            </p>
          </li>
        </ul>
      ) : null}
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar"
        aria-controls="navbar"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse"
        id="navbar"
        style={{ flexGrow: showToolsAndCompany ? 1 : 0 }}
      >
        <ul className={`navbar-nav ${showToolsAndCompany ? "ml-auto" : ""}`}>
          {!user ? (
            <li className="d-lg-none nav-item pr-1 text-nowrap text-white">
              <a className="nav-link text-white" href="/">
                Start Learning For Free
              </a>
            </li>
          ) : null}
          {showToolsAndCompany ? (
            <>
              {user ? <li className="nav-item"><a className="nav-link" href="/dashboard">Today</a></li> : null}
              {user ? <li className="nav-item"><a className="nav-link" href="/readiness">Readiness</a></li> : null}
              <li className="nav-item"><a className="nav-link" href="/curriculum">Learn</a></li>
              <li className="nav-item"><a className="nav-link" href="/challenges/daily">Practice</a></li>
              <li className="nav-item"><a className="nav-link" href="/companies">Companies</a></li>
            </>
          ) : null}

          {user?.paid_active ? (
            <li className="nav-item pr-1 my-1 dropdown text-nowrap">
              <a className="nav-link" href="/forum">
                Community
              </a>
            </li>
          ) : null}

          {!(user && user.paid_active) ? (
            <button
              className="ad-nav-upgrade my-lg-1 mr-2"
              onClick={() => window.location.replace("/subscriptions/new")}
            >
              Upgrade
            </button>
          ) : null}
          {!user ? (
            <>
              <li className="nav-item">
                <a className="nav-link my-lg-1" href="/users/sign_in">
                  Login
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link my-lg-1" href="/users/sign_up">
                  Sign Up
                </a>
              </li>
            </>
          ) : null}

          <li
            id="toolsDropdownLi"
            className="nav-item pr-1 my-1 dropdown text-nowrap"
          >
            <a
              className="nav-link dropdown-toggle"
              href="#"
              id="toolsDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Resources
            </a>
            <div
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="toolsDropdown"
            >
              <Link className="dropdown-item" to="/flash-cards">
                Flash cards
              </Link>
              <a className="dropdown-item" href="/videos">
                Video library
              </a>
              <Link className="dropdown-item" to="/courses/generate">
                Custom course
              </Link>
              <a className="dropdown-item" href="/blog">Interview field notes</a>
              <a className="dropdown-item" href="/latest">
                Latest additions
              </a>
              {user ? <Link className="dropdown-item" to="/activity-log">Activity log</Link> : null}
              <a className="dropdown-item" href="/global_search">Search resources</a>
              {user ? (
                <div
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "0.25rem 1.5rem",
                    clear: "both",
                    fontWeight: "400",
                    color: "#212529",
                    textAlign: "inherit",
                    whiteSpace: "nowrap",
                    backgroundColor: "transparent",
                    border: "0",
                  }}
                >
                  <form
                    className="form-inline"
                    id="global-search-form"
                    onSubmit={(event) => {
                      event.preventDefault();
                      window.location.href =
                        "/global_search?query=" + encodeURIComponent(searchVal.trim());
                    }}
                  >
                    <input
                      className="form-control w-100"
                      type="text"
                      placeholder="Search AlgoDaily"
                      aria-label="Search AlgoDaily"
                      id="global-search-input"
                      onChange={(e) => {
                        setSearchVal(e.target.value);
                      }}
                    />
                  </form>
                </div>
              ) : null}
            </div>
          </li>
          {user && <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href="#" id="appAccountDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Account</a>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="appAccountDropdown">
              <a className="dropdown-item" href="/users/edit">Settings &amp; membership</a>
              <a className="dropdown-item" href="/jobapps">Interview pipeline</a>
              <Link className="dropdown-item" to="/activity-log">Activity log</Link>
              <a className="dropdown-item" href="/leaderboard">Leaderboard</a>
              <a className="dropdown-item" href="/users/sign_out" data-method="delete">Log out</a>
            </div>
          </li>}
        </ul>

        {!props.hideSidebars && showTutorialMenuBtn && (
          <button
            type="button"
            className="d-none d-lg-block ad-nav-icon-button ml-2"
            onClick={() =>
              dispatch({
                type: actions.SET_SCREEN_LIST_OPEN,
                payload: !screenListOpen,
              })
            }
            data-tip="Toggle the right hand task menu"
            data-place="left"
            aria-label="Toggle lesson tasks"
          >
            <i className="fa fa-tasks" aria-hidden="true"></i>
          </button>
        )}
      </div>
    </nav>
  );
};

export default AppNav;
